import { Instance } from 'mobx-state-tree';
import { InvitingUserDtoModelBase } from './InvitingUserDtoModel.base';

/* The TypeScript type of an instance of InvitingUserDtoModel */
export interface InvitingUserDtoModelType extends Instance<typeof InvitingUserDtoModel.Type> {}

/* A graphql query fragment builders for InvitingUserDtoModel */
export { selectFromInvitingUserDto, invitingUserDtoModelPrimitives, InvitingUserDtoModelSelector } from './InvitingUserDtoModel.base';

/**
 * InvitingUserDtoModel
 */
export const InvitingUserDtoModel = InvitingUserDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
